import request from '@/api/axios' // 引入axios文件

// 注册用户管理-负责人【查看成员
export const getUserTerms = (data) =>
	request({
		url: '/api/users/getUserTerms',
		method: 'post',
		data
	})
// 查询媒体报道
export const userMediaReports = (params) =>
	request({
		url: '/api/userMediaReports',
		method: 'get',
		params: params
	})
// 导出信息
export const downloads = (params, data) =>
	request({
		url: '/api/userMatchBasic/downloadCustomize',
		method: 'POST',
		responseType: 'blob',
		data,
		params
	})
export const download = (params) =>
	request({
		url: '/api/userMatchBasic/download',
		method: 'POST',
		responseType: 'blob',
		data,
		params
	})
// 下载附件
export const toZipOne = (params) =>
	request({
		url: '/api/userMatchBasic/toZipOne',
		method: 'get',
		responseType: 'blob',
		params
	})
// 下载附件
export const toZipOneMatchBonus = (params) =>
	request({
		url: '/api/userMatchBasic/toZipOneMatchBonus',
		method: 'get',
		responseType: 'blob',
		params
	})
// 批量下载
export const toZip = (params, data) =>
	request({
		url: '/api/userMatchBasic/batchDownload',
		method: 'post',
		responseType: 'blob',
		data,
		params
	})
// 插入记录
export const userDownloadRecord = (data) =>
	request({
		url: '/api/userDownloadRecord',
		method: 'post',
		data
	})
// 下载记录
export const userDownloadRecord_get = (params) =>
	request({
		url: '/api/userDownloadRecord',
		method: 'get',
		params
	})
// 新增媒体报道
export const userMediaReportsAdd = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'post',
		data
	})
// 修改媒体报道
export const userMediaReportsEditor = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'put',
		data
	})
// 上传时间列表
export const userMatchTime_get = () =>
	request({
		url: '/api/userMatchTime',
		method: 'get'
	})
// 上传时间列表
export const userMatchTime_get_c = () =>
	request({
		url: '/api/userMatchTime/c',
		method: 'get'
	})
// 编辑
export const userMatchTime_put = (data) =>
	request({
		url: '/api/userMatchTime',
		method: 'put',
		data
	})
// 删除媒体报道
export const userMediaReportsDelete = (data) =>
	request({
		url: '/api/userMediaReports',
		method: 'delete',
		data
	})
// 查询成果展示
export const userAchievement = (params) =>
	request({
		url: '/api/userAchievement',
		method: 'get',
		params
	})
// 新增成果展示
export const userAchievementAdd = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'post',
		data
	})
// 修改成果展示
export const userAchievementEditor = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'put',
		data
	})
// 删除成果展示
export const userAchievementDelete = (data) =>
	request({
		url: '/api/userAchievement',
		method: 'delete',
		data
	})
// 用户管理列表
export const queryRegisterUser = (params) =>
	request({
		url: '/api/users/queryRegisterUser',
		method: 'get',
		params
	})
// 修改用户状态
export const updateUserStatus = (data) =>
	request({
		url: '/api/users/updateUserStatus',
		method: 'put',
		data
	})
// 新增用户
export const usersAdd = (data) =>
	request({
		url: '/api/users',
		method: 'post',
		data
	})
	// 下载用户信息
export const userDownload = (params) =>
	request({
		url: '/api/users/register/download',
		method: 'get',
		responseType: 'blob',
		params
	})
// 修改密码
export const updatePass = (data) =>
	request({
		url: '/api/users/updatePasswordReset',
		method: 'post',
		data
	})
// 报名信息日志 列表
export const userMatchBasic = (params) =>
	request({
		url: '/api/userMatchBasic/getAllMatch',
		method: 'get',
		params
	})
// 详情
export const getMatchById = (params) =>
	request({
		url: '/api/userMatchBasic/getMatchById',
		method: 'get',
		params
	})
// 评审 获奖领取
export const upOrdown = (data) =>
	request({
		url: '/api/userMatchBasic/upOrdown',
		method: 'put',
		data
	})
export const upOrdowns = (data) =>
	request({
		url: '/api/userMatchBasic/award/upOrdown',
		method: 'put',
		data
	})
// 批量审核
export const upOrdownBatch = (data) =>
	request({
		url: '/api/userMatchBasic/upOrdownBatch',
		method: 'put',
		data
	})
// 查看日志
export const userMatchLog = (params) =>
	request({
		url: '/api/userMatchLog',
		method: 'get',
		params
	})
// 信息通知列表
export const userMessage = (params) =>
	request({
		url: '/api/userMessage',
		method: 'get',
		params
	})
// 查了信息详情
export const findByMessageId = (params) =>
	request({
		url: '/api/userMessage/findByMessageId',
		method: 'get',
		params
	})
// 删除信息通知
export const userMessageRemove = (data) =>
	request({
		url: '/api/userMessage',
		method: 'delete',
		data
	})
// 查询树结构
export const querySendPersion = (params) =>
	request({
		url: '/api/userMessage/querySendPersion',
		method: 'get',
		params
	})
export const userMessageSend = (data) =>
	request({
		url: '/api/userMessage',
		method: 'post',
		data
	})
// 模板
export const templateCode = (params) =>
	request({
		url: '/api/templateCode',
		method: 'get',
		params
	})
// 获取验证码
export const code = () =>
	request({
		url: '/auth/code',
		method: 'get'
	})
// 登录
export const login = (data) =>
	request({
		url: '/auth/login',
		method: 'post',
		data
	})
// 上传图片
export const pictures = (data) =>
	request({
		url: '/api/localStorage/pictures',
		method: 'post',
		data
	})
// c端登陆
export const login_c = (data) =>
	request({
		url: '/user/auth/login/c',
		method: 'post',
		data
	})
// c端注册
export const register_c = (data) =>
	request({
		url: '/user/auth/register/c',
		method: 'post',
		data
	})
//  获取手机验证码
export const mobileCode = (params) =>
	request({
		url: '/auth/mobileCode',
		method: 'get',
		params
	})
// c端找回密码
export const forgotPassword_c = (data) =>
	request({
		url: '/user/auth/forgotPassword/c',
		method: 'post',
		data
	})
// c端我的比赛
export const queryOnePerson_c = (params) =>
	request({
		url: '/api/userMatchBasic/queryOnePerson/c',
		method: 'get',
		params
	})
// c端修改密码
export const updatePass_c = (data) =>
	request({
		url: '/api/users/updatePass/c',
		method: 'post',
		data
	})
// c端信息通知
export const queryHasRead_c = (params) =>
	request({
		url: '/api/userMessage/queryHasRead/c',
		method: 'get',
		params
	})
// c端我的比赛查看
export const getMatchById_c = (params) =>
	request({
		url: '/api/userMatchBasic/getMatchById/c',
		method: 'get',
		params
	})
// c端日志查看
export const queryLog_c = (params) =>
	request({
		url: '/api/userMatchLog/queryLog/c',
		method: 'get',
		params
	})
// c端删除
export const delete_c = (data) =>
	request({
		url: '/api/userMatchBasic/delete/c',
		method: 'delete',
		data
	})
// 大赛报名
export const create_c = (data) =>
	request({
		url: '/api/userMatchBasic/create/c',
		method: 'post',
		data
	})
// c端撤回
export const withdraw_c = (data) =>
	request({
		url: '/api/userMatchBasic/withdraw/c',
		method: 'put',
		data
	})
// c端下载模板
export const downloadTemplate_c = (params) =>
	request({
		url: 'api/userMatchBasic/downloadTemplate/c',
		method: 'get',
		responseType: 'blob',
		params
	})
// c端修改报名信息
export const update_c = (data) =>
	request({
		url: '/api/userMatchBasic/update/c',
		method: 'put',
		data
	})
// c端查看信息详情
export const findByMessageId_c = (params) =>
	request({
		url: '/api/userMessage/findByMessageId/c',
		method: 'get',
		params
	})
// c端信息列表
export const queryPersonMessage_c = (params) =>
	request({
		url: '/api/userMessage/queryPersonMessage/c',
		method: 'get',
		params
	})
// c端上传文件
export const localStorage_c = (data) =>
	request({
		url: '/api/localStorage/c',
		method: 'post',
		data
	})
// 学院列表
export const dictDetail_c = (params) =>
	request({
		url: '/api/dictDetail/c',
		method: 'get',
		params
	})
// 成果展示
export const userAchievement_c = (params) =>
	request({
		url: '/api/userAchievement/home/c',
		method: 'get',
		params
	})
// c端补充材料
export const userMatchSupplement_c = (data) =>
	request({
		url: '/api/userMatchSupplement/create/c',
		method: 'post',
		data
	})

export const userMediaReports_c = (params) =>
	request({
		url: '/api/userMediaReports/home/c',
		method: 'get',
		params
	})
// 手机验证码登录
export const loginbycode = (params) =>
	request({
		url: '/user/auth/loginbycode',
		method: 'post',
		params
	})

// 上传浏览器
export const uploadChrome = (data) =>
	request({
		url: '/api/userBrowserManage',
		method: 'post',
		data
	})
// b 端文件上传
export const localStorage_b = (data) =>
	request({
		url: '/api/localStorage',
		method: 'post',
		data
	})

export const codeStorage_c = (data) =>
	request({
		url: '/auth/mobileCode',
		method: 'post',
		data
	})

export const getChromeList = (params) =>
	request({
		url: '/api/userBrowserManage',
		method: 'get',
		params
	})
export const deleteChromeList = (data) =>
	request({
		url: '/api/userBrowserManage',
		method: 'delete',
		data
	})
  //新增获奖项目table表格带入
  export const getPrizeGroup = (params) =>
	request({
		url: '/api/userMatchBasic/getAllMatchBonus',
		method: 'get',
		params
	})
	//sec-新增获奖项目table表格带入
	export const getPrizeGroupNew = (params) =>
		request({
			url: '/api/userMatchBasic/getAllMatchBonus/new',
			method: 'get',
			params
		})
  //新增获奖项目
  export const addPrizeGroup = (data) =>
	request({
		url: '/api/userMatchBasic/award/updateUserMatchBasicAward',
		method: 'post',
		data
	})

//查询个人比赛基本信息
export const getUserInfo = (params) =>
request({
  url: '/api/userMatchBasic/queryOnePerson/c',
  method: 'get',
  params
})
//根据id查询比赛
export const getTeacherInfo = (params) =>
request({
  url: '/api/userMatchBasic/getMatchById/c',
  method: 'get',
  params
})
//下载领奖信息表附件（模板）
export const downfileBonus = (params) =>
request({
  url: '/api/userMatchBasic/downloadTemplate/excel/c',
  method: 'get',
  responseType: 'blob',
  params
})
//下载企业授权委托书（模板）
export const downfileAuth = (params) =>
request({
  url: '/api/userMatchBasic/downloadTemplate/c',
  method: 'get',
  responseType: 'blob',
  params
})
//提交领奖材料
export const addBonusForm = (data) =>
request({
  url: '/api/userMatchBasic/award/create',
  method: 'post',
  data
})